import type { EbmSpec } from './schema';

export const ebmMigrations: Record<number, (data: unknown) => EbmSpec> = {
  1: (data) => data as EbmSpec,
};
